<template>
  <div v-if="!loading">
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-title>نمایش دوره ها</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="3" lg="3">
            <v-select color="black" v-model="order" label="نوع ترتیب دوره ها را انتخاب کنید" :items="orderItems"
                      item-text="name" @change="getCourses"></v-select>
          </v-col>
          <v-col cols="12" sm="12" md="3" lg="3">
            <v-select
                color="black"
                v-model="dictationCourseFilter"
                label="فیلتر نوع دوره"
                :items="dictationCourseFilterItems"
                item-text="name"
                item-value="value"
                @change="onDictationCourseFilterChange">
            </v-select>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6" class="text-left">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="hover-link mx-1"
                        color="teal"
                        v-bind="attrs"
                        v-on="on" @click="$router.push('/courses/setting')">mdi-cog
                </v-icon>
              </template>
              <span class="tooltip-text">تنظیمات دوره ها</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon x-large class="hover-link mx-1"
                        color="success"
                        v-bind="attrs"
                        v-on="on" @click="$router.push('/courses/create')">mdi-plus
                </v-icon>
              </template>
              <span class="tooltip-text">ساخت دوره جدید</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-data-table
                align="center"
                :single-expand="singleExpand"
                :expanded.sync="expanded"
                item-key="id"
                show-expand
                :headers="headers"
                :items="courses.data"
                :items-per-page="10"
                disable-sort
                expand-icon="mdi-chevron-up"
                hide-default-footer>
              <template v-slot:top>
                <v-toolbar flat>
                  <v-spacer></v-spacer>
                  <v-switch
                      v-model="singleExpand"
                      label="فقط یک سطر باز شود."
                      class="mt-2"
                  ></v-switch>
                </v-toolbar>
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <v-row>
                    <v-col cols="6">توضیحات :
                      {{ item.description }}
                    </v-col>
                    <v-col cols="6">زیر نویس :
                      {{ item.sub_title }}
                    </v-col>
                    <v-col cols="12">اطلاعات :
                      {{ item.details }}
                    </v-col>
                  </v-row>
                </td>
              </template>
              <template
                  v-slot:[`item.operation`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon @click="$router.push('/courses/items/assign/'+item.id)"
                            v-bind="attrs"
                            v-on="on"
                            class="mx-1" color="info"
                    >
                      mdi-relation-many-to-many
                    </v-icon>
                  </template>
                  <span class="tooltip-text">اتصال دوره به درس ها</span>
                </v-tooltip>


                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon @click="$router.push('/courses/items/order/'+item.id)"
                            v-bind="attrs"
                            v-on="on"
                            class="mx-1" color="teal"
                    >
                      mdi-order-numeric-descending
                    </v-icon>
                  </template>
                  <span class="tooltip-text">ترتیب درس های دوره</span>
                </v-tooltip>


                <v-icon class="mx-1" color="purple" @click="$router.push('/courses/edit/'+item.id)">mdi-pen</v-icon>
                <v-icon class="mx-1" color="error" @click="destroy(item.id)">mdi-trash-can-outline</v-icon>
              </template>
              <template
                  v-slot:[`item.cover_file`]="{ item }">
                <img :src="item.cover_file" height="150" width="150" :alt="item.title">
              </template>
              <template
                  v-slot:[`item.banner`]="{ item }">
                <img :src="item.banner" height="150" width="150" :alt="item.title">
              </template>
              <template
                  v-slot:[`item.visibility`]="{ item }">
                <span v-if="item.visibility">قابل مشاهده</span>
                <span v-else>مخفی</span>
              </template>
              <template
                  v-slot:[`item.show_index`]="{ item }">
                <span v-if="item.show_index">قابل مشاهده</span>
                <span v-else>مخفی</span>
              </template>
              <template
                  v-slot:[`item.is_dictation_course`]="{ item }">
                <span v-if="item.is_dictation_course">دیکته</span>
                <span v-else>معمولی</span>
              </template>
              <template
                  v-slot:[`item.installment_duration`]="{ item }">
                <span>{{ item.installment_duration }} روز</span>
              </template>
              <template
                  v-slot:[`item.duration`]="{ item }">
                <span>{{ item.duration }} ماه</span>
              </template>
              <template
                  v-slot:[`item.discount`]="{ item }">
                <span>{{ item.discount }} %</span>
              </template>
              <template
                  v-slot:[`item.total_buy_discount`]="{ item }">
                <span>{{ item.total_buy_discount }} %</span>
              </template>
              <template
                  v-slot:[`item.price`]="{ item }">
                {{
                  Intl.NumberFormat('en-US').format(item.price)
                }} &nbsp; تومان
              </template>
              <template
                  v-slot:[`item.installment_price`]="{ item }">
                {{
                  Intl.NumberFormat('en-US').format(item.installment_price)
                }} &nbsp; تومان
              </template>
              <template
                  v-slot:[`item.total_time`]="{ item }">
                {{ item.total_time }} ثانیه
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12">
            <v-pagination
                class="text-center"
                color="#696CFF"
                v-model="courses.current_page"
                :length="courses.last_page"
                circle
                @input="getCourses"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="deleteDialog" max-width="50vw">
      <v-card class="ma-0">
        <v-row class="ma-0">
          <v-col cols="12">
            آیا از حذف این دوره اطمینان دارید؟
          </v-col>
          <v-col cols="6">
            <v-btn color="warning" @click="finalDestroy">
              بله
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn color="success" @click="deleteDialog=false">
              خیر
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "CourseIndex",
  data() {
    return {
      selectedEntityId: null,
      deleteDialog: false,
      expanded: [],
      singleExpand: false,
      loading: true,
      orderItems: [
        {name: 'بر اساس مدت', value: 'duration'},
        {name: 'بر اساس قیمت', value: 'price'},
        {name: 'بر اساس زمان فایل ها', value: 'total_time'},
        {name: 'بر اساس نمایش در صفحه اصلی', value: 'show_index'},
        {name: 'بر اساس وضعیت نمایش', value: 'visibility'},
        {name: 'بر اساس زمان ساخت', value: 'created_at'},
      ],
      dictationCourseFilterItems: [
        {name: 'نمایش همه دوره ها', value: ''},
        {name: 'نمایش دوره های دیکته', value: 1},
      ],
      dictationCourseFilter: '',
      order: 'created_at',
      courses: {
        current_page: 1
      },
      headers: [
        {text: 'شناسه', value: 'id', align: 'center', width: '2%'},
        {text: 'عنوان', value: 'title', align: 'center', width: '10%'},
        {text: 'نام دسته بندی', value: 'category_name', align: 'center', width: '10%'},
        {text: 'قیمت', value: 'price', align: 'center', width: '5%'},
        {text: 'مدت دوره', value: 'duration', align: 'center', width: '3%'},
        {text: 'تخفیف', value: 'discount', align: 'center', width: '5%'},
        {text: 'تخفیف خرید کلی', value: 'total_buy_discount', align: 'center', width: '3%'},
        {text: 'تعداد اقساط', value: 'installment_count', align: 'center', width: '3%'},
        {text: 'مدت هر قسط', value: 'installment_duration', align: 'center', width: '3%'},
        {text: 'قیمت هر قسط', value: 'installment_price', align: 'center', width: '5%'},
        {text: 'بنر', value: 'banner', align: 'center'},
        {text: 'کاور', value: 'cover_file', align: 'center'},
        {text: 'وضعیت مشاهده', value: 'visibility', align: 'center', width: '2%'},
        {text: 'نمایش در صفحه اصلی', value: 'show_index', align: 'center', width: '6%'},
        {text: 'نوع دوره', value: 'is_dictation_course', align: 'center', width: '4%'},
        {text: 'کل زمان فایل های دوره', value: 'total_time', align: 'center', width: '6%'},
        {text: 'عملیات', value: 'operation', align: 'center', width: '15%'},
      ],
    }
  },
  mounted() {
    this.getCourses()
  },
  methods: {
    finalDestroy() {
      window.axios.delete('course/crud/delete/' + this.selectedEntityId).then(() => {
        this.getCourses()
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      }).finally(() => {
        this.deleteDialog = false
      })
    },
    onDictationCourseFilterChange() {
      this.courses.current_page = 1
      this.getCourses()
    },
    getCourses() {
      let url = '/course/crud/index?page=' + this.courses.current_page ?? 1
      url = url + '&order=' + this.order
      if (this.dictationCourseFilter !== '') {
        url = url + '&is_dictation_course=' + this.dictationCourseFilter
      }
      window.axios.get(url).then((res) => {
        this.courses = res.data.data
        this.loading = false
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
    destroy(courseId) {
      this.selectedEntityId = courseId
      this.deleteDialog = true
    }
  }
}
</script>

<style scoped>

</style>
